export default "__VITE_ASSET__17abbf58__"